import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  // Redirect to auth-options if the user is not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/auth-options" />;
  }

  return children;
};

export default ProtectedRoute;
